import { render } from "./FormImageItem.vue?vue&type=template&id=392e99d0"
import script from "./FormImageItem.vue?vue&type=script&lang=js"
export * from "./FormImageItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__